(function ($) {
	function copyToClipboard(element) {
		var oldValue = $(element).html();

		navigator.clipboard.writeText(oldValue);

		$(element).html("COPIADO");
		setTimeout(function () {
			$(element).html(oldValue);
		}, 300);
	}

	$(document).on("click", "cupom", function (e) {
		e.preventDefault();
		e.stopPropagation();
		copyToClipboard(this);
	});

})(jQuery);
